import { defineStore } from "pinia";
import { ref } from "vue";
import { getMe, login as loginRequest, logout as logoutRequest, type CurrentUser } from "@a/auth";

export const useAuthStore = defineStore("auth", () => {
    const user = ref<CurrentUser | null>(null);
    const loaded = ref(false);

    async function ensureLoaded(): Promise<void> {
        if (loaded.value) {
            return;
        }
        user.value = await getMe();
        loaded.value = true;
    }

    async function login(email: string, password: string): Promise<boolean> {
        const result = await loginRequest({ email, password });
        if (result) {
            user.value = result;
            loaded.value = true;
        }
        return result !== null;
    }

    async function logout(): Promise<void> {
        await logoutRequest();
        user.value = null;
    }

    return { user, ensureLoaded, login, logout };
});
